export default __webpack_public_path__ + "static/media/0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39.66dbd6d9.png";